export default __webpack_public_path__ + "static/media/img_muslinTwoBibsTwoEars_rg.b0369752.jpg";